import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/back.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f7928180")

_pushScopeId("data-v-f7928180")
const _hoisted_1 = { class: "index" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "transform-mask"
}
const _hoisted_4 = {
  ref: "audioBackgroundMusic",
  src: "",
  preload: "",
  loop: "loop"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EnterVideo = _resolveComponent("EnterVideo")
  const _component_RightNav = _resolveComponent("RightNav")
  const _component_BackgroundIframe = _resolveComponent("BackgroundIframe")
  const _component_OutsideIframe = _resolveComponent("OutsideIframe")
  const _component_HotspotPopContainer = _resolveComponent("HotspotPopContainer")
  const _component_AnswerPopContainer = _resolveComponent("AnswerPopContainer")
  const _component_PrefacePopContainer = _resolveComponent("PrefacePopContainer")
  const _component_CartoonFigure = _resolveComponent("CartoonFigure")
  const _component_van_share_sheet = _resolveComponent("van-share-sheet")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.backShow)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "back-wrapper",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["stop","prevent"]))
        }, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (_ctx.transformMaskShow)
      ? (_openBlock(), _createBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_EnterVideo, {
      show: _ctx.isEnterVideoShow,
      url: _ctx.enterVideoUrl,
      poster: _ctx.enterVideoPoster,
      skipShow: _ctx.enterVideoSkipShow,
      onClick: _ctx.videoClick,
      onEnd: _ctx.videoEnd
    }, null, 8, ["show", "url", "poster", "skipShow", "onClick", "onEnd"]),
    _createVNode(_component_RightNav, {
      show: _ctx.isRightNavShow,
      onAction: _ctx.navClick,
      musicOn: _ctx.audioBackgroundMusicPlaying
    }, null, 8, ["show", "onAction", "musicOn"]),
    (_ctx.backgroundIframeIndex === -1)
      ? (_openBlock(), _createBlock(_component_BackgroundIframe, {
          key: 2,
          class: "background-iframe",
          id: `backgroundIframe1`,
          url: _ctx.backgroundIframeUrl
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.backgroundIframeIndex === 1)
      ? (_openBlock(), _createBlock(_component_BackgroundIframe, {
          key: 3,
          class: "background-iframe",
          id: `backgroundIframe2`,
          url: _ctx.backgroundIframeUrlDefault
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.backgroundIframeIndex === 2)
      ? (_openBlock(), _createBlock(_component_BackgroundIframe, {
          key: 4,
          class: "background-iframe",
          id: `backgroundIframe3`,
          url: _ctx.backgroundIframeUrlSecond
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OutsideIframe, {
      url: _ctx.outsideIframeUrl,
      show: _ctx.outsideIframeUrlShow
    }, null, 8, ["url", "show"]),
    _createVNode(_component_HotspotPopContainer, {
      spot: _ctx.popSpot,
      spotData: _ctx.popSpotData,
      spotComponent: _ctx.popSpotComponent,
      show: _ctx.popShow,
      audioBackgroundPlaying: _ctx.audioBackgroundPlaying,
      onClose: _ctx.popClose,
      onAudioaction: _ctx.audioAction,
      onAudiostop: _ctx.audioClose,
      onAudiosingleplay: _ctx.hotSpotAudioSinglePlay
    }, null, 8, ["spot", "spotData", "spotComponent", "show", "audioBackgroundPlaying", "onClose", "onAudioaction", "onAudiostop", "onAudiosingleplay"]),
    _createVNode(_component_AnswerPopContainer, {
      show: _ctx.answerPopShow,
      onClose: _ctx.answerPopClose
    }, null, 8, ["show", "onClose"]),
    _createVNode(_component_PrefacePopContainer, {
      show: _ctx.prefacePopShow,
      onClose: _ctx.prefacePopClose
    }, null, 8, ["show", "onClose"]),
    _createVNode(_component_CartoonFigure, {
      show: _ctx.cartoonShow,
      cartoonActionIndex: _ctx.cartoonActionIndex,
      showTalk: _ctx.cartoonTalkShow,
      talkContent: _ctx.cartoonTalkContent,
      onClickaction: _ctx.cartoonAudioPlay
    }, null, 8, ["show", "cartoonActionIndex", "showTalk", "talkContent", "onClickaction"]),
    _createVNode(_component_van_share_sheet, {
      show: _ctx.showShare,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showShare = $event)),
      title: "立即分享给好友",
      options: _ctx.shareOptions,
      onSelect: _ctx.shareSelect
    }, null, 8, ["show", "options", "onSelect"]),
    _createVNode("audio", {
      ref: "audioBackground",
      src: "",
      autoplay: "",
      preload: "",
      onEnded: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.audioEnd && _ctx.audioEnd(...args)))
    }, null, 544),
    _createVNode("audio", _hoisted_4, null, 512)
  ]))
})